export default __webpack_public_path__ + "static/BasierCircle-MediumItalic-0843ba641bb5b36556e38270f1ed5227.woff";